module.exports = __webpack_public_path__ + "static/media/Foto 5 riter ochoa sosa.2d98a897.jpg";